import selectTodosByQuery from './selectTodosByQuery';

const selectTodosBySchedule = (state, schedule, includeArchived = false) => (
  schedule ? selectTodosByQuery(state, {
    scheduleIds: { contains: schedule.id }
  }, includeArchived) : []
);

export default selectTodosBySchedule;
